<template>
  <tr v-if="product">
    <td>
      <div style="margin-bottom: 10px"> {{ product.name }} </div>
      <el-tag v-if="product.category" size="small" type="info"> {{ product.category }} </el-tag>
    </td>
    <td>
      <el-input-localized-numeric
        v-model="product.purchase_price"
        :disabled="true"
        size="mini"
      />
      <el-button
        size="mini"
        style="margin-top: 5px; width: 100%;"
        plain
        type="primary"
        @click="reCalculate"
      >
        Újraszámol <i class="el-icon-d-arrow-right"></i>
      </el-button>
    </td>
    <price-cell
      v-for="priceType in priceTypes"
      ref="price"
      :key="priceType.id"
      :product="product"
      :price-type="priceType"
      :default-representative-price="product.representative_prices.find(p => p.price_type_id === priceType.id)"
      :normal-price="product.representative_prices.find(p => p.price_type_id === normalPrice.id)"
    />
  </tr>
</template>

<script>
import PriceCell from './PriceCell';

export default {
  components: { PriceCell },
  props: ['priceTypes', 'defaultProduct', 'PriceCell', 'normalPrice'],
  data() {
    return {
      product: null,
    };
  },
  watch: {
    defaultProduct(newVal) {
      this.product = JSON.parse(JSON.stringify(newVal));
    },
  },
  mounted() {
    this.product = JSON.parse(JSON.stringify(this.defaultProduct));
  },
  methods: {
    reCalculate() {
      this.$refs['price'].forEach(priceRef => {
        priceRef.reCalculate();
      });
    },
    getPrice() {
      const prices = [];
      this.$refs['price'].forEach(row => row.isChanged() && prices.push(row.representativePrice));
      return prices;
    },
  },
};
</script>
